import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {CandidateDocsItem, IUser} from "../../../../assets/types/dtoTypes";

@Injectable( {
  providedIn: 'root',
} )
export class AgencyDashboardPageService {
  private http = inject(HttpClient);

  private usersUrl = `${environment.apiUrl}/users/my-institution/users`;

  private translateUrl = `${environment.apiUrl}/docs/materials`;

  private userUrl = `${environment.apiUrl}/users`;

  private materialsUrl = `${environment.apiUrl}/materials`;

  private docsUrl      = `${environment.apiUrl}/docs`;

  constructor() {}


  getUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>(this.usersUrl);
  }

  deleteUser(id: string): Observable<void> {
    const url = `${this.userUrl}/${id}`;
    return this.http.delete<void>(url);
  }

  deleteMaterial(materialId: string) {
    const url = `${this.materialsUrl}/${materialId}`;
    return this.http.delete<void>(url);
  }

  translateDocument(materialId: string, sourceLang: string, targetLang: string) {
    const url = `${this.translateUrl}/${materialId}/translate`;
    return this.http.post( url, {sourceLang, targetLang });
  }

  getCandidateDocuments(candidateId: string): Observable<CandidateDocsItem[]> {
    const url = `${this.docsUrl}/candidates/${candidateId}/documents`;
    return this.http.get<CandidateDocsItem[]>(url);
  }

  uploadSigned(materialId: string, url: string) {
    return this.http.post(
      `${this.docsUrl}/materials/${materialId}/signed`,
      { url }
    );
  }

}
